import WeightLabeledInput from './WeightLabeledInput';

export default WeightLabeledInput;
